var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1104_2334",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 2H6C4.1 2 2.5 3.6 2.5 5.5V18.5C2.5 20.4 4.1 22 6 22H16.5L22.5 16V5.5C22.5 3.6 20.9 2 19 2ZM13.5 17H11.5V15H13.5V16M13.5 13H11.5V7H13.5V12M15.5 20V18.5C15.5 16.6 17.1 15 19 15H20.5L15.5 20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H6C4.1 2 2.5 3.6 2.5 5.5V18.5C2.5 20.4 4.1 22 6 22H16.5L22.5 16V5.5C22.5 3.6 20.9 2 19 2ZM13.5 17H11.5V15H13.5V16M13.5 13H11.5V7H13.5V12M15.5 20V18.5C15.5 16.6 17.1 15 19 15H20.5L15.5 20Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22V23H16.9142L17.2071 22.7071L16.5 22ZM22.5 16L23.2071 16.7071L23.5 16.4142V16H22.5ZM11.5 17H10.5V18H11.5V17ZM11.5 15V14H10.5V15H11.5ZM13.5 15H14.5V14H13.5V15ZM11.5 13H10.5V14H11.5V13ZM11.5 7V6H10.5V7H11.5ZM13.5 7H14.5V6H13.5V7ZM15.5 20H14.5V22.4142L16.2071 20.7071L15.5 20ZM20.5 15L21.2071 15.7071L22.9142 14H20.5V15ZM19 1H6V3H19V1ZM6 1C3.54772 1 1.5 3.04772 1.5 5.5H3.5C3.5 4.15228 4.65228 3 6 3V1ZM1.5 5.5V18.5H3.5V5.5H1.5ZM1.5 18.5C1.5 20.9523 3.54772 23 6 23V21C4.65228 21 3.5 19.8477 3.5 18.5H1.5ZM6 23H16.5V21H6V23ZM17.2071 22.7071L23.2071 16.7071L21.7929 15.2929L15.7929 21.2929L17.2071 22.7071ZM23.5 16V5.5H21.5V16H23.5ZM23.5 5.5C23.5 3.04772 21.4523 1 19 1V3C20.3477 3 21.5 4.15228 21.5 5.5H23.5ZM13.5 16H11.5V18H13.5V16ZM12.5 17V15H10.5V17H12.5ZM11.5 16H13.5V14H11.5V16ZM12.5 15V16H14.5V15H12.5ZM13.5 12H11.5V14H13.5V12ZM12.5 13V7H10.5V13H12.5ZM11.5 8H13.5V6H11.5V8ZM12.5 7V12H14.5V7H12.5ZM16.5 20V18.5H14.5V20H16.5ZM16.5 18.5C16.5 17.1523 17.6523 16 19 16V14C16.5477 14 14.5 16.0477 14.5 18.5H16.5ZM19 16H20.5V14H19V16ZM19.7929 14.2929L14.7929 19.2929L16.2071 20.7071L21.2071 15.7071L19.7929 14.2929Z",
    fill: "white",
    fillOpacity: 0.8,
    mask: "url(#path-1-inside-1_1104_2334)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.7f8e7a24e16d457e4a3fad2d5249213a.svg";
export { ForwardRef as ReactComponent };